import { useEffect } from 'react'
import { storage } from 'utils/storage'
import { getUrl } from 'utils/url'

const Redirect = () => {
  useEffect(() => {
    const userSheetId = storage.getValue('FF_UserSheetId')
    const tunnelId = storage.getValue('FF_TunnelId')
    const insukind = storage.getValue('FF_Insukind')
    const route = storage.getValue('FF_Route')

    if (!userSheetId || !route || !insukind || !tunnelId)
      globalThis.location.replace(getUrl(import.meta.env.VITE_ENV, 'home'))
    else globalThis.location.replace(`/${insukind}/${route}`)
  }, [])

  return null
}

export default Redirect
